export const nhomKhachHang = {
  sections: { list: { title: 'Nhóm khách hàng' } },
  filter: {
    searchPlaceholder: 'Tìm theo mã, tên nhóm, ghi chú',
    textDetailTitle: 'Bộ lọc chi tiết',
    statusSection: 'Trạng thái',
    sortSection: 'Sắp xếp',
    sortField: 'Trường sắp xếp',
    sortDir: 'Chiều sắp xếp',
  },
  status: {
    all: 'Tất cả',
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  sort: {
    ngayTao: 'Ngày tạo',
    ma: 'Mã nhóm',
    tenNhom: 'Tên nhóm',
  },
  filters: {
    groupTreeSection: 'Nhóm khách hàng',
    treeAll: 'Tất cả nhóm',
    treeSearch: 'Tìm kiếm nhóm khách hàng',
  },
  fields: {
    code: 'Mã nhóm',
    name: 'Tên nhóm',
    note: 'Ghi chú',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
  },
  titles: { add: 'Thêm nhóm KH', edit: 'Sửa nhóm KH' },
  actions: {
    quickAdd: 'Thêm nhanh nhóm khách hàng',
  },
  messages: {
    noData: 'Không có dữ liệu',
    loadError: 'Không tải được danh sách',
    createSuccess: 'Đã tạo nhóm khách hàng',
    updateSuccess: 'Đã cập nhật nhóm khách hàng',
    deleteSuccess: 'Đã xóa nhóm khách hàng',
    notFound: 'Không tìm thấy nhóm',
    confirmDelete: 'Xóa nhóm «{name}»?',
    listSummary: 'Tổng số {count} nhóm khách hàng',
    selectedCount: 'Đã chọn: {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} nhóm khách hàng đã chọn? (Xóa từng nhóm qua API.)',
    bulkDeleteSuccess: 'Đã xóa {count} nhóm khách hàng',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} nhóm không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn nhóm nào để xóa',
  },
  validation: {
    maRequired: 'Vui lòng nhập mã nhóm',
    maInvalid: 'Mã nhóm chỉ gồm chữ, số, dấu gạch ngang (-) hoặc gạch dưới (_), không chứa khoảng trắng',
    tenRequired: 'Vui lòng nhập tên nhóm',
  },
  import: {
    description: 'Chọn file Excel theo mẫu tải về. Hệ thống xử lý import trên server.',
    success: 'Import nhóm khách hàng thành công',
    failed: 'Import nhóm khách hàng thất bại',
    noData: 'Không có dòng dữ liệu hợp lệ trong file',
  },
}
